import React from 'react';
import { inject, observer } from 'mobx-react';
import { Link, mergeStyleSets, FontWeights, Text, getTheme } from '@fluentui/react';
import { Plan } from 'shared/services/license/';
import { getSubscribeLink } from 'src/services/license';

const theme = getTheme();
const styles = mergeStyleSets({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    fontSize: '100px',
    marginTop: '16px',
  },

  header: {
    padding: '18px 24px 12px',
  },
  title: [
    theme.fonts.xLarge,
    {
      margin: 0,
      fontWeight: FontWeights.semilight,
    },
  ],
  inner: {
    height: '100%',
    padding: '0 24px 20px',
  },
  actions: {
    position: 'relative',
    marginTop: 20,
    width: '100%',
    whiteSpace: 'nowrap',
  },
  subtext: [
    theme.fonts.small,
    {
      margin: 0,
      fontWeight: FontWeights.semilight,
    },
  ],
  link: [
    theme.fonts.medium,
    {
      color: theme.palette.neutralPrimary,
    },
  ],
});

const LockedFeature = ({ userStore, plans: originalPlans }) => {
  const { activation_code } = userStore.license.rawLicense;
  const plans = (originalPlans ?? []).filter(x => ![Plan.Trial, Plan.Personal].includes(x))
    .map((plan, i, array) => ({ name: plan, isLast: array.length - 1 === i, isOneBeforeLast: array.length - 2 === i }));

  return (
    <>
      <div className={styles.header}>
        <Text className={styles.title} >
          This feature is not available for your plan
        </Text>
      </div>
      <div className={styles.inner}>
        <Text className={styles.subtext}>
          {`To unlock this feature buy `}
          { plans.map((plan, i) => {
              return (
                <React.Fragment key={i}>
                  <Link href={getSubscribeLink(plan.name, activation_code)} target="_blank" key={i}>{plan.name}</Link>
                  { plan.isLast ? '' : plan.isOneBeforeLast ? ' or ' : ', ' }
                </React.Fragment>
              )
            })
          }
          { ' plan.' }
        </Text>

        <div className={styles.actions}>
          <Link className={styles.link} href="https://www.xappex.com/enabler4excel-editions-pricing/" target="_blank">
            Compare plans
          </Link>
        </div>
      </div>
    </>
  );
}

export default inject('userStore')(observer(LockedFeature));